var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_916_48061)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 37.5898,
    r: 32,
    fill: "url(#paint0_linear_916_48061)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_916_48061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9933 30.9496C53.1138 30.2797 53.9523 29.2249 54.352 27.9821C53.2991 28.6068 52.1471 29.0469 50.9458 29.2833C49.2803 27.5215 46.6414 27.0927 44.5038 28.2367C42.3661 29.3806 41.2589 31.8139 41.8008 34.1771C37.4878 33.9606 33.4695 31.9232 30.7458 28.5721C29.3243 31.0239 30.0507 34.1581 32.4058 35.7346C31.5542 35.7072 30.7214 35.4766 29.977 35.0621C29.977 35.0846 29.977 35.1071 29.977 35.1296C29.9775 37.6835 31.7775 39.8834 34.2808 40.3896C33.4909 40.6045 32.6623 40.6361 31.8583 40.4821C32.5623 42.6662 34.5752 44.1624 36.8695 44.2071C34.9693 45.6985 32.6226 46.5073 30.207 46.5033C29.7789 46.504 29.351 46.4793 28.9258 46.4296C31.3788 48.0059 34.2337 48.8425 37.1495 48.8396C41.2061 48.8674 45.1046 47.2682 47.9729 44.3996C50.8413 41.531 52.4402 37.6324 52.412 33.5758C52.412 33.3433 52.4066 33.1121 52.3958 32.8821C53.4463 32.1228 54.353 31.1823 55.0733 30.1046C54.0945 30.5384 53.0564 30.8232 51.9933 30.9496Z",
    fill: "#9E120E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_916_48061",
    x: 0,
    y: 0.589844,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_916_48061"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.308333 0 0 0 0 0.285208 0 0 0 0 0.285208 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_916_48061"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_916_48061",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_916_48061",
    x: 19,
    y: 18.5898,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_916_48061"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_916_48061",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_916_48061",
    x1: 10,
    y1: 37.5898,
    x2: 74,
    y2: 37.5898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.70d3a192623b01a648c897549f8fc008.svg";
export { ForwardRef as ReactComponent };